import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/holiday-party-catering-hero.jpg'
import holidayPartyCatering1 from 'assets/img/holiday-party-catering-1.jpg'
import holidayPartyCatering2 from 'assets/img/holiday-party-catering-2.jpg'
import holidayPartyCatering3 from 'assets/img/holiday-party-catering-3.jpg'

export default function HolidayPartyCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Holiday Party Catering With Food Trucks - Roaming Hunger</title>
        <meta name="og:title" content="Holiday Party Catering With Food Trucks"></meta>
        <meta name="description" content="The holiday season means many things. To us, it means the grocery stores start playing “Jingle Bells”, menorahs appear in window sills, and the movie Elf is constantly on TV. Whatever you celebrate..."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Holiday Party Catering"
          onButtonClick={openModal}
          description={(
            <div>
              This holiday season make your celebration delicious. Whether the party is at the office
              or at home, we’ll make the food at your event festive and memorable.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Make Your Holiday Party All About the Food
        </h2>
        <p className="font-light text-gray-900 mt-6">
          The holiday season means many things. To us, it means the grocery stores start playing
          “Jingle Bells”, menorahs appear in window sills, and the movie Elf is constantly on TV.
          Whatever you celebrate, regardless of where you are, we’ll bring the flavors of the
          holiday right to you.
        </p>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Catering Options for All 12 Days of Christmas"
          content="Give the gift of delicious food and satisfy the entire office. From lobster rolls, to tacos, to gourmet salads, our tasty options are designed to make everyone happy, regardless of dietary restrictions or preferences."
          image={holidayPartyCatering1}
          reverse
        />
        <OccasionPageGridRow
          heading="Your Personal Santa's Helper"
          content="Talk to one of our experts and work together to find a truck for your event. We've helped thousands of customers coordinate logistics and ensured that their food truck catering went smoothly. We do it all - except find the perfect gift for your in-laws."
          image={holidayPartyCatering2}
        />
        <OccasionPageGridRow
          heading="Save the Stress"
          content="Sit back, enjoy a glass of mulled wine, watch your guests dive into a delicious meal and then watch the mess drive away. We simplify the steps of booking the best gourmet food trucks so your party catering is covered. Being the host with the most this holiday season has never been easier."
          image={holidayPartyCatering3}
          reverse
        />
      </OccasionPageGrid>


      <HowItWorks
        heading="How Holiday Party Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Holiday Party Catering Works"
        onButtonClick={openModal}
      />

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <Calculator
        heading="How Much Does Holiday Party Catering Cost?"
        onButtonClick={openModal}
      />

      <FeaturedClients
        onButtonClick={openModal}
      />
    </Layout>
  )
}
